import { render, staticRenderFns } from "./tooltip-tab.vue?vue&type=template&id=1d6e3537"
import script from "./tooltip-tab.vue?vue&type=script&lang=js"
export * from "./tooltip-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports